/**
 * Floating Navigation JS
 * - Syncs cart count with real header
 * - Hamburger triggers original mobile drawer
 * - Search/cart icons trigger existing drawers
 * - Marks active nav link based on current URL
 * - Handles announcement bar height offset
 */

(function () {
  'use strict';

  var floatingNav = document.getElementById('floating-nav');
  if (!floatingNav) return;

  // ── Active link highlight ────────────────────────────────
 var currentPath = window.location.pathname.replace(/\/$/, ''); // remove trailing slash

var allLinks = floatingNav.querySelectorAll('.floating-nav__menu-link, .floating-nav__carousel-link');

allLinks.forEach(function(link) {
  var linkPath = link.getAttribute('href');

  if (!linkPath) return;

  linkPath = linkPath.replace(/\/$/, ''); // normalize

  // ✅ match exact OR startsWith (for filters, pagination, etc.)
  if (currentPath === linkPath || currentPath.startsWith(linkPath)) {
    link.classList.add('is-active');
  }
});

  // ── Announcement bar offset ──────────────────────────────
  function adjustForAnnouncementBar() {
    var annoBar = document.querySelector('.shopify-section--announcement-bar');
    if (annoBar) {
      var barHeight = annoBar.offsetHeight;
      if (barHeight > 0) {
        floatingNav.style.top = (8 + barHeight) + 'px';
      }
    }
  }
  // adjustForAnnouncementBar();
  // window.addEventListener('resize', adjustForAnnouncementBar);

  // ── Cart count sync ──────────────────────────────────────
  var cartCountEl = floatingNav.querySelector('.floating-nav__cart-count');

  function syncCartCount(count) {
    if (!cartCountEl) return;
    count = parseInt(count, 10) || 0;
    cartCountEl.textContent = count > 0 ? count : '';
    cartCountEl.setAttribute('data-count', count);
  }

  // Init from main header
  var mainCartCount = document.querySelector('.header__cart-count');
  if (mainCartCount) {
    syncCartCount(mainCartCount.textContent);
  }

  // Listen for Focal theme cart updates
  document.addEventListener('cart:updated', function(e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
    syncCartCount(count);
  });

  // MutationObserver fallback
  if (mainCartCount && window.MutationObserver) {
    new MutationObserver(function() {
      syncCartCount(mainCartCount.textContent);
    }).observe(mainCartCount, { childList: true, characterData: true, subtree: true });
  }

  // ── Hamburger → opens existing mobile menu drawer ────────
  var hamburgerBtn = floatingNav.querySelector('.floating-nav__hamburger');
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function() {
      var orig = document.querySelector('[aria-controls="mobile-menu-drawer"]');
      if (orig) orig.click();
    });
  }

  // ── Search icon → triggers search drawer ─────────────────
  var searchBtn = floatingNav.querySelector('[data-floating-search]');
  if (searchBtn) {
    searchBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var orig = document.querySelector('[aria-controls="search-drawer"]');
      if (orig) orig.click();
    });
  }

  // ── Cart icon → triggers mini-cart or cart page ──────────
  var cartBtn = floatingNav.querySelector('[data-floating-cart]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      var orig = document.querySelector('[aria-controls="mini-cart"]');
      if (orig) {
        orig.click();
      } else {
        window.location.href = '/cart';
      }
    });
  }

})();
